import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { rootReducer } from "./reducers";
import { navigationMiddleware } from "logic/middlewares/navigation";

export const store = createStore(
  rootReducer,
  applyMiddleware(thunk, navigationMiddleware)
);
